import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  orgListData: [],
  orgListPaginationData: {},
  addOrgModal: false,
  createdORGSuccess: false,
  userList: [],
  pagination: {},
};

export const orgSlice = createSlice({
  name: "org",
  initialState,
  reducers: {
    orglistLoad: (state) => {
      state.loading = true;
    },
    orglistSuccess: (state, action) => {
      state.loading = false;
      state.orgListData = action.payload.list;
      state.orgListPaginationData = action.payload.pagination;
    },
    orglistFailure: (state) => {
      state.loading = false;
    },
    createOrgLoad: (state) => {
      state.loading = true;
      state.createdORGSuccess = false;
    },
    editOrgLoad: (state) => {
      state.loading = true;
      state.createdORGSuccess = false;
    },
    createOrgSuccess: (state) => {
      state.addOrgModal = false;
      state.loading = false;
      state.createdORGSuccess = true;
    },
    createOrgFailure: (state) => {
      state.loading = false;
      state.createdORGSuccess = false;
    },
    addOrgModalHandler: (state) => {
      state.addOrgModal = !state.addOrgModal;
    },

    orgUserListLoad: (state) => {
      state.loading = true;
      state.error = true;
    },
    orgUserExportListLoad: (state) => {
      state.loading = true;
      state.error = true;
    },

    orgUserListSuccess: (state, action) => {
      state.loading = true;
      state.error = true;
      state.userList = action.payload.data;
      state.pagination = action.payload.pagination;
    },
    orgUserListFail: (state) => {
      state.loading = true;
      state.error = true;
    },

    editOrgUserLoad: (state) => {
      state.loading = true;
    },

    editOrgUserSuccess: (state, action) => {
      state.loading = false;
    },
    editOrgUserFail: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const {
  orglistLoad,
  orglistFailure,
  orglistSuccess,
  createOrgLoad,
  createOrgSuccess,
  createOrgFailure,
  addOrgModalHandler,

  editOrgLoad,

  //// User List
  orgUserExportListLoad,
  orgUserListLoad,
  orgUserListSuccess,
  orgUserListFail,

  editOrgUserLoad,
  editOrgUserSuccess,
  editOrgUserFail,
} = orgSlice.actions;
export default orgSlice.reducer;
